import { render, staticRenderFns } from "./ThesaurusList.vue?vue&type=template&id=eaadf39c&scoped=true&"
import script from "./ThesaurusList.vue?vue&type=script&lang=js&"
export * from "./ThesaurusList.vue?vue&type=script&lang=js&"
import style0 from "./ThesaurusList.vue?vue&type=style&index=0&id=eaadf39c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaadf39c",
  null
  
)

export default component.exports